module.exports = __webpack_public_path__ + "img/pIndex-m-slide1.3f38295b.jpg";